import React, { useEffect } from 'react'
import AziendaFrom from '../../rightSidebar/AziendaFrom'
import { Box } from '@mui/material'
// import TerreniForm from '../Terreni/TerreniForm'
import StabilimentiForm from '../Stabilimenti/StabilimentiForm'
import {useDispatch, useSelector } from 'react-redux'
export const CantineStabilimentiSlider = ({cantine,setCantine}) => {
    // const singleData = useSelector((state) => state?.stabilimenti?.singleStabilimento);
    // const dispatch = useDispatch()
    // useEffect(() => {
    //     // dispatch(fetchTerreni())
    //     dispatch(fetchSingleStabilimento())
    // },[dispatch])
    const cantineSingleData = useSelector((state)=> state.cantine.singleCantines)
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un stabilimento</h2>
            </Box>
            <StabilimentiForm cantine={cantine} setCantine={setCantine} cantineSingleData={cantineSingleData} />
        </Box>
    )
}